import { Component, OnInit, ViewChild } from '@angular/core';
import { FormFieldComponent } from '@lockton-apps/shared/ui/lui';
import {
  FieldWrapper,
  ɵdefineHiddenProp as defineHiddenProp,
} from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';

export interface FormlyFieldProps extends FormlyFieldSelectProps {
  // insert additional props here
  readonly?: boolean;
}

@Component({
    selector: 'lockton-apps-form-field-wrapper',
    templateUrl: './form-field-wrapper.component.html',
    styleUrls: ['./form-field-wrapper.component.scss'],
    standalone: false
})
export class FormFieldWrapperComponent extends FieldWrapper implements OnInit {
  @ViewChild(FormFieldComponent, { static: true })
  formField!: FormFieldComponent;

  ngOnInit(): void {
    defineHiddenProp(this.field, '_formField', this.formField);
  }
}
